import React, { useGlobal } from "reactn";
import PropTypes from "prop-types";

import SideNav from "shared-anpost-components/components/SideNav/SideNav";
import DetectDeviceResize from "shared-anpost-components/hooks/detectDeviceResizeHook";

import BlankScreen from "../_common/blankScreen/blankScreen";
import LeftContainerStyled from "../_common/containers/LeftContainer/LeftContainer.styled";
import RightContainerStyled from "../_common/containers/RightContainer/RightContainer.styled";
import profileHooks from "../../hooks/profileHooks";

/**
 * @param {{
 *  children: React.ReactNode,
 * }} props
 */

const Layout = ({ children }) => {
    const [isCollapsed] = useGlobal("isCollapsed");
    const [isBusiness] = useGlobal("isBusiness");
    const [values] = useGlobal("values");

    const { activeTab } = profileHooks();

    const { isMobile } = DetectDeviceResize();

    return (
        <>
            {!values.loggedIn && <BlankScreen fullPage />}
            <LeftContainerStyled className={isCollapsed ? "collapsed" : ""}>
                {!isMobile && <SideNav isMyDelivery business={isBusiness} isOverview={activeTab === "my-deliveries"} />}
            </LeftContainerStyled>
            <RightContainerStyled className={isCollapsed ? "collapsed" : ""}>{children}</RightContainerStyled>
        </>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired
};

export default Layout;
